let nativeNavs = document.querySelector(".header__inline-menu .header__menu-item");

function adjustTheMobileMegaMenuDropdown(){
  let drawerNavigation = document.querySelector(".menu-drawer__navigation .menu-drawer__menu");
  let megaMenuContainer = document.querySelector(".mega-menu-container");
  let megaMenuDropdowns = megaMenuContainer.querySelectorAll("ul.mobile-mega-menu");
  let drawerNavigations = drawerNavigation.querySelectorAll("li");
  drawerNavigations.forEach(function(drawerNavItem){
      if(drawerNavItem.hasAttribute("data-mobile-dropdown-rel")){
          let dropDownRel = drawerNavItem.getAttribute("data-mobile-dropdown-rel");
          console.log({dropDownRel});
          megaMenuDropdowns.forEach(function(megaMenuDropdown){
            console.log({megaMenuDropdown});
              if(megaMenuDropdown.hasAttribute("data-mobile-dropdown")){
                  let megaMenuDropdownTarget = megaMenuDropdown.getAttribute("data-mobile-dropdown");
                  if(megaMenuDropdownTarget === dropDownRel && drawerNavItem.querySelector("ul.menu-drawer__menu.list-menu")){
                      drawerNavItem.querySelector("ul.menu-drawer__menu.list-menu").innerHTML = megaMenuDropdown.innerHTML;
                  }
              }
          })
      }
  })
}

function adjustTheDesktopMegaMenuDropdown(){

  let megaMenuDropDowns = document.querySelectorAll("header-menu .mega-menu__content");
  let megaMenuContainers = document.querySelectorAll(".dropdown_mega_menu");
  // let menuTargetElement = menuElement.getAttribute("summary-for");

  megaMenuDropDowns.forEach(function(megaMenuDropDown){
    let dropdownTarget = megaMenuDropDown.getAttribute("target-for");

    megaMenuContainers.forEach(function(megaMenuContainer){ 
      let megaMenuContainerTarget = megaMenuContainer.getAttribute("target-for");
      if(megaMenuContainerTarget == dropdownTarget){
        megaMenuDropDown.innerHTML = megaMenuContainer.innerHTML;
      }
    })
    
  })
  
  // let drawerNavigation = document.querySelector(".menu-drawer__navigation .menu-drawer__menu");
  // let megaMenuContainer = document.querySelector(".mega-menu-container");
  // let megaMenuDropdowns = megaMenuContainer.querySelectorAll("ul.mobile-mega-menu");
  // let drawerNavigations = drawerNavigation.querySelectorAll("li");
  // drawerNavigations.forEach(function(drawerNavItem){
  //     if(drawerNavItem.hasAttribute("data-mobile-dropdown-rel")){
  //         let dropDownRel = drawerNavItem.getAttribute("data-mobile-dropdown-rel");
  //         console.log({dropDownRel});
  //         megaMenuDropdowns.forEach(function(megaMenuDropdown){
  //             if(megaMenuDropdown.hasAttribute("data-mobile-dropdown")){
  //                 let megaMenuDropdownTarget = megaMenuDropdown.getAttribute("data-mobile-dropdown");
  //                 if(megaMenuDropdownTarget === dropDownRel){
  //                     drawerNavItem.querySelector("ul.menu-drawer__menu.list-menu").innerHTML = megaMenuDropdown.innerHTML;
  //                 }
  //             }
  //         })
  //     }
  // })
}

window.addEventListener("load", function(){
  document.querySelectorAll('details[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  
    if (summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }
  
    function onHoverMenu(){
      let menuItemParent = summary.parentNode;
      console.log(menuItemParent)
      if(menuItemParent.classList.contains(".mega-menu")){
        
      }
      let menuContainers = summary.closest("header").querySelectorAll("details.mega-menu");
      console.log({menuContainers})
      if(menuContainers.length == 0){
         menuContainers = summary.closest("header").querySelectorAll("details");
      }
      
      menuItemParent.addEventListener('mouseover', (event) => {
        menuContainers.forEach(function(menuContainer){
          menuContainer.removeAttribute("open");
        })
        menuItemParent.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        menuItemParent.setAttribute('open', '');
      });
  
      menuContainers.forEach(function(menuContainer){
        let menuContainerBody = menuContainer.closest("header-menu").querySelector(".mega-menu__content");
          menuContainerBody.addEventListener('mouseleave', (event) => {
        console.log("...");
           if(event.currentTarget.closest("header-menu").querySelector('details').hasAttribute('open')){
            menuItemParent.setAttribute('aria-expanded', event.currentTarget.closest("header-menu").querySelector('details').hasAttribute('open'));
            menuItemParent.removeAttribute('open');
           }
          });
      })
    }
    
    if(window.innerWidth >= 990){
      onHoverMenu();
    }
  });
})

document.addEventListener("DOMContentLoaded", function(){
  adjustTheMobileMegaMenuDropdown();
  adjustTheDesktopMegaMenuDropdown();
})

document.addEventListener('DOMContentLoaded', function() {
  
  // Section load event
  document.addEventListener('shopify:section:load', function(event) {
    adjustTheMobileMegaMenuDropdown(event);
    adjustTheDesktopMegaMenuDropdown(event);
  });

  // Section unload event
  document.addEventListener('shopify:section:unload', function(event) {
    adjustTheMobileMegaMenuDropdown(event);
    adjustTheDesktopMegaMenuDropdown(event);
  });

  // Section select event
  document.addEventListener('shopify:section:select', function(event) {
    adjustTheMobileMegaMenuDropdown(event);
    adjustTheDesktopMegaMenuDropdown(event);
  });

  // Section deselect event
  document.addEventListener('shopify:section:deselect', function(event) {
    adjustTheMobileMegaMenuDropdown(event);
    adjustTheDesktopMegaMenuDropdown(event);
  });

  // Block select event
  document.addEventListener('shopify:block:select', function(event) {
    adjustTheMobileMegaMenuDropdown(event);
    adjustTheDesktopMegaMenuDropdown(event);
  });

  // Block deselect event
  document.addEventListener('shopify:block:deselect', function(event) {
    adjustTheMobileMegaMenuDropdown(event);
    adjustTheDesktopMegaMenuDropdown(event);
  });

});
var isMobile = false; //initiate as false
// device detection
if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
    isMobile = true;
    setTimeout(function() {
        var banHeight = $(".promo_banner-show .promo_banner").innerHeight()
        if (banHeight > 30) {
            $(".index-sections .under-menu:nth-child(1)").css("margin-top", banHeight - 30);
            $(".page_banner").css("margin-top", 46 + banHeight + "px");
        }

    }, 2000);

}  
